import { render, staticRenderFns } from "./ChatIcon.vue?vue&type=template&id=31a460be&scoped=true&"
import script from "./ChatIcon.vue?vue&type=script&lang=js&"
export * from "./ChatIcon.vue?vue&type=script&lang=js&"
import style0 from "./ChatIcon.vue?vue&type=style&index=0&id=31a460be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a460be",
  null
  
)

export default component.exports